<div class="flex flex-col">
  <label class="text-sm font-semibold">{{ label }}</label>
  <div class="flex items-center">
    <span *ngIf="isCurrency; else defaultText" class="break-words">{{ getDisplayText() | currency:'BRL':'':'1.2-2'
      }}</span>
    <ng-template #defaultText>
      <span class="break-words">{{getDisplayText()}}</span>
    </ng-template>
  </div>
</div>